import { ButtonIcon } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

type ChatMessageAudioPlayPauseButtonProps = {
  isPlaying: boolean;
  togglePlay: () => void;
  color: string;
  bgColor: string;
};

export const ChatMessageAudioPlayPauseButton = ({
  isPlaying,
  togglePlay,
  color,
  bgColor,
}: ChatMessageAudioPlayPauseButtonProps) => (
  <ButtonIcon
    aria-label="toggle-play-audio"
    onClick={togglePlay}
    rounded="full"
    bgColor={bgColor}
  >
    <Icon name={isPlaying ? iconNames.pause : iconNames.play} fill={color} />
  </ButtonIcon>
);
